import * as React from "react"
import { Skeleton } from "@mui/material"
import { FORMAT_DATE_BACK, formatDate, translateCountryName } from "@ui-seeker/utils"

import { LabelCountry, AppTableSeeker } from "@components"
import { useToast } from "@hooks"
import { WEBBACK_V2_API } from "@constants"
import { useRetailersTracked } from "../../@hooks"
import { retailersTrackedData, retailersTrackedDate } from "../../@signals"
import RetailersTrackedTableToolbar from "./Toolbar"

export default function RetailersTrackedTable() {
	const { isLoading } = useRetailersTracked()
	const { showToast } = useToast()

	if (isLoading) return <Skeleton variant="rectangular" height={500} />

	return <AppTableSeeker
		title="Last Data Available Per Retailer"
		data={retailersTrackedData.value}
		textLabels={{ body: { noMatch: 'No data available for the selected date.' } }}
		options={{
			rowsPerPage: 20,
			rowsPerPageOptions: [20, 50, 100],
			onDownload: () => showToast.promiseExcel(`${WEBBACK_V2_API}/pricing/retailers-tracked/excel`, { date: formatDate(retailersTrackedDate.value, { format: FORMAT_DATE_BACK }) }),
			customToolbar: () => <RetailersTrackedTableToolbar />,
		}}
		columns={[
			{
				name: 'country',
				label: 'Country',
				options: {
					display: 'excluded',
					customBodyRowRender: v => translateCountryName(v)
				}
			},
			{
				name: 'retailer',
				label: 'Retailer',
				options: {
					headerAlign: 'left',
					customBodyRowRenderLite: (value, { country }) => <LabelCountry country={country} label={value} />
				}
			},
			{
				name: 'numSkus',
				label: 'Num. SKUs',
				options: {
					setCellProps: () => ({ align: 'center' }),
					setCellHeaderProps: () => ({ align: 'center' })
				}
			},
			{
				name: 'numBrands',
				label: 'Num. brands',
				options: {
					setCellProps: () => ({ align: 'center' }),
					setCellHeaderProps: () => ({ align: 'center' })
				}
			},
			{
				name: 'firstExtraction',
				label: 'First extraction',
				options: {
					setCellProps: () => ({ align: 'center' }),
					setCellHeaderProps: () => ({ align: 'center' }),
					customBodyRowRender: value => formatDate(value, { isString: true })
				}
			},
			{
				name: 'lastExtraction',
				label: 'Last extraction',
				options: {
					setCellProps: () => ({ align: 'center' }),
					setCellHeaderProps: () => ({ align: 'center' }),
					customBodyRowRender: value => formatDate(value, { isString: true })
				}
			},
		]}
	/>
}
